import { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'

import { ParametersContext } from '@pages/Parameters/Parameters'

import { TextSettings } from '@components/TextSettings'

export const VisualParameters: FC = () => {
  const { t } = useTranslation()

  const {
    isEdit,
    initialGlobalColumnHeaderStyles,
    columnHeaderSettingsRef,
    initialGlobalColumnTextStyles,
    columnTextSettingsRef,
    onTextExternalDirty,
    onHeaderExternalDirty,
  } = useContext(ParametersContext)

  return (
    <Grid container flexDirection='column'>
      <Typography variant='h6'>{t('parameters.visual.title')}</Typography>
      <TextSettings
        ref={columnHeaderSettingsRef}
        backgroundSettings={false}
        borderSettings={false}
        isEdit={isEdit}
        labelText={t('parameters.visual.columnHeader')}
        initialTextState={
          initialGlobalColumnHeaderStyles ? initialGlobalColumnHeaderStyles : undefined
        }
        onSetExternalDirty={onHeaderExternalDirty}
      />
      <TextSettings
        ref={columnTextSettingsRef}
        initialTextState={initialGlobalColumnTextStyles ? initialGlobalColumnTextStyles : undefined}
        isEdit={isEdit}
        labelText={t('parameters.visual.columnText')}
        onSetExternalDirty={onTextExternalDirty}
      />
    </Grid>
  )
}
